import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-24_01",
  version: "2026.06.24",
  date: "24 Jun 2026",
  sinceCommit: "3f8830d",
  gameplay: [
    {
      text: "**Matchmaking**: allow spectating other players' matches",
    },
    {
      text: "Matchmaking: if no opponents are found within **1 minute**, a match starts anyway and empty seats are filled with **Master**-tier bots at your preferred lobby size.",
    },
    {
      text: "**Achievements** added for signed-in players — damage milestones, spell discovery, synergies, PvP wins, PvE boss clears, and more. Progress unlocks on your profile.",
    },
    {
      text: "DoT and zone damage (burn, blizzard ticks, void drain, etc.) now shows clearer aggregated combat numbers instead of spamming every tick.",
    },
    {
      text: "**PvE** economy refined: prep shop budgets **2 SP**, **2 PP**, and **~210g** (was flat **300g**); slot **2** starts **Sanctuary** instead of Scourge. Boss clears award SP/PP/Sy like Classic round wins plus performance-based gold (up to **+60g** from damage dealt). Shop between encounters has **no timer** — ready up when your team is done.",
    },
    {
      text: "Boss briefing waits for **every player to ready up** before the fight starts — no auto-start timer.",
    },
    {
      text: "Add **quick join queue**: when others are in queue for a game, you'll get a top-of-screen prompt to join their queue.",
    },
    {
      text: "**Skill Draft**: eligible synergy skills can appear in any passive step",
    }
  ],
  skills: [],
};
